import React, { FunctionComponent } from 'react'
import classNames from 'classnames'
import Styles from './BreadcrumbItem.module.scss'

interface BreadcrumbItemProps {
  text?: React.ReactNode
  className?: string
  href?: string
  rel?: string
  active?: boolean
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
}

const BreadcrumbItem: FunctionComponent<BreadcrumbItemProps> = ({
  href,
  text,
  className,
  rel = 'noreferrer',
  children,
  active,
  ...props
}) => {
  return (
    <span
      className={classNames(Styles.item, active && Styles.active, className)}
    >
      {href ? (
        <a href={href} rel={rel} {...props}>
          {text}
        </a>
      ) : (
        [text, children]
      )}
    </span>
  )
}

export default BreadcrumbItem
